// extracted by mini-css-extract-plugin
export var time_to_read = "time_to_read-7jd";